import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import * as fromPrice from './reducers/price.reducer';
import {PriceEffects} from './effects/price.effects';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature('price', fromPrice.reducer),
    EffectsModule.forFeature([PriceEffects]),
  ]
})
export class PriceModule { }
